export function recoveryKey(key) {
  return `${key}.recovery`;
}

export function parseGameSave(raw) {
  if (raw === null) return { status: 'empty', value: null, recoveryRaw: null };
  try {
    const value = JSON.parse(raw);
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      throw new Error('invalid save root');
    }
    return { status: 'ok', value, recoveryRaw: null };
  } catch {
    return { status: 'corrupt', value: null, recoveryRaw: raw };
  }
}

export function readGameSave(storage, key) {
  if (!storage || !key) {
    return { status: 'unavailable', value: null, recoveryRaw: null };
  }

  let raw;
  try {
    raw = storage.getItem(key);
  } catch {
    return { status: 'unavailable', value: null, recoveryRaw: null };
  }
  const parsed = parseGameSave(raw);
  if (parsed.status === 'corrupt') {
    // Preserve the exact bytes before normal gameplay writes a fresh ledger.
    // This is best-effort because quota/privacy restrictions may block even
    // the quarantine write; recoveryRaw still remains downloadable in memory.
    try {
      storage.setItem(recoveryKey(key), parsed.recoveryRaw);
    } catch {
      // Keep returning the in-memory recovery copy.
    }
    return parsed;
  }
  return parsed;
}

export function writeGameSave(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
    return { ok: true };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : 'Browser storage is unavailable.',
    };
  }
}

export function clearGameSave(storage, key) {
  try {
    storage.removeItem(key);
    storage.removeItem(recoveryKey(key));
    return { ok: true };
  } catch (error) {
    return {
      ok: false,
      error: error instanceof Error ? error.message : 'Browser storage is unavailable.',
    };
  }
}
